module.exports = __webpack_public_path__ + "media/images/en/pdf-fbf06b58253f0d09bc154d9f17762cfb.png";